import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import { compact, get, isArray, isEmpty } from 'lodash';
import SpinnerError from '../../utils/SpinnerError';
import useLabel from '../../utils/Translations/useLabel';
import useT from '../../utils/Translations/useT';
import getGqlOperationName from '../../../utils/getGqlOperationName';
import orgStructureGroupSelectorQuery from '../../../data/orgStructureGroupSelector.graphql';
import useResetOnDeps from './hooks/useResetOnDeps';
import MultiselectFilter from './MultiselectFilter';
const OrgStructureGroupSelector = ({ title, orgGroupId, orgGroupSelectorName, filter: filterValues, disabled = false, value = [], onChange, dataCy, ...rest }) => {
    const t = useT();
    const _title = useLabel('Group', title);
    const organisationGroupIds = useMemo(() => {
        const ids = orgGroupSelectorName && (filterValues === null || filterValues === void 0 ? void 0 : filterValues[orgGroupSelectorName]);
        return isArray(ids) ? ids : compact([ids !== null && ids !== void 0 ? ids : orgGroupId]);
    }, [filterValues, orgGroupSelectorName, orgGroupId]);
    useResetOnDeps({ organisationGroupIds }, onChange, []);
    const { data, loading, error } = useQuery(orgStructureGroupSelectorQuery, {
        variables: { organisationGroupIds },
        skip: isEmpty(organisationGroupIds),
    });
    const options = useMemo(() => get(data, getGqlOperationName(orgStructureGroupSelectorQuery), []), [data]);
    // With no groups the list says so, instead of a "Select All" that reads as
    // ticked above nothing.
    const hasOptions = !isEmpty(options);
    return (<SpinnerError error={error} inline={false} loading={loading}>
      <MultiselectFilter hasCountBadge dataCy={dataCy} disabled={isEmpty(organisationGroupIds) || disabled} liveSearch={hasOptions} options={options} orderOptionsBy="name" showSelectAll={hasOptions} title={_title} value={value} onChange={onChange} {...rest}>
        {hasOptions ? null : (<li className="p-10 text-muted">{t('No groups available')}</li>)}
      </MultiselectFilter>
    </SpinnerError>);
};
export default OrgStructureGroupSelector;
